import { render, staticRenderFns } from "./AppealProcessCompleteRspToLeaveGrantedPg.vue?vue&type=template&id=08644626&scoped=true"
import script from "./AppealProcessCompleteRspToLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./AppealProcessCompleteRspToLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08644626",
  null
  
)

export default component.exports